import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FormattedMessage } from 'react-intl';

import FrequentlyQuestion from './FrequentlyQuestion';

const FrequentlyAskedQuestions = () => (
    <div className="faq-container">
        <Container>
            <Row>
                <Col lg={{ span: 10, offset: 1 }} md={12}>
                    <div className='sell-tickets__header mt-3'>
                        <h2 className="sell-tickets__header__1">
                            <span className='sell-tickets-header__title'><FormattedMessage id='sell_faq_title'/></span>
                        </h2>
                    </div>
                    <div className="faq-content mb-5">
                        <FrequentlyQuestion question={<FormattedMessage id="question1"/>} answer={<FormattedMessage id="answer1"/>} />
                        <FrequentlyQuestion question={<FormattedMessage id="question2"/>} answer={<FormattedMessage id="answer2"/>} />
                        <FrequentlyQuestion question={<FormattedMessage id="question3"/>} answer={<FormattedMessage id="answer3"/>} />
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
);

export default FrequentlyAskedQuestions;
